import LOGO from "../images/FoxImpresos.png";

export const Team__FoxImpresos = {
  name: "Tachiquines",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#F97316",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 62 + 54 + 40,
  goalsScoredAgainst: 52 + 33 + 28,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
